export default __webpack_public_path__ + "static/media/06AW1AUG66.c5b81f53.jpg";